import React from 'react'
import { Switch, Route, useRouteMatch } from 'react-router-dom'
import List from './List'

const BabyApproved = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <List />
      </Route>
    </Switch>
  )
}

export default BabyApproved
